<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <v-btn v-on="on" class="cvc-button mr-2">
            <div v-bind="tooltip.attrs" v-on="tooltip.on">
              <v-icon>mdi-rocket-launch</v-icon>
            </div>
          </v-btn>
        </template>
        <span>Release</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        <span class="pl-2 pt-2 font-size-medium-large font-weight-medium">
          Are you sure?
        </span>
      </v-card-title>
      <v-card-text class="mt-3">
        <span>
          Releasing {{profile.name}} will allow frameworks to fetch
          this profile.
        </span>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          class="cvc-button"
          depressed width="100px"
          @click="hideDialogForProfile">
          No
        </v-btn>
        <v-btn
          class="cvc-button"
          depressed width="100px"
          @click="releaseProfile">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {toTitleCase} from "@/helpers/TextUtils";

export default {
  name: "ReleaseProfileModal",
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: null,
      toTitleCase: toTitleCase
    }
  },
  methods: {
    releaseProfile() {
      this.$store.dispatch('releaseProfile', {
        id: this.profile.id,
        version: this.profile.latestVersion
      }).then(() => {
        this.hideDialogForProfile();
      });
    },
    hideDialogForProfile() {
      this.dialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
